import { GuidedTourStep } from '../../../model/guided-tour-step';
import { HighlightDialogConfig } from '../../../model/highlight-dialog';

export const MyEmployeeSteps: GuidedTourStep[] = [
  {
    highlightTargetId: 'employees-tile-content',
    clickTargetId: 'employees',
    description: { text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step1' },
    border: 30,
    hideArrow: true,
  },
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'checkbox-header-table',
    nextOnOverlayClick: true,
    border: 30,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step3',
    },
  },
  {
    highlightTargetId: 'remove-user-button',
    nextOnOverlayClick: true,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step4',
    },
  },
  {
    highlightTargetId: 'action-button-0',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step5',
    },
    border: -10,
  },
  {
    highlightTargetId: 'markant-body',
    shape: 'rectangle',
    ignoreHighlightClick: true,
    hideBackButton: true,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'remove-user-button-members-page',
    nextOnOverlayClick: true,
    border: 20,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step7',
    },
  },
  {
    highlightTargetId: 'my-employees-tour-highlight-dialog',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step8',
    },
    shape: 'rectangle',
    ignoreHighlightClick: true,
  },
  {
    highlightTargetId: 'platform-role-0',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step9',
    },
    border: 50,
    nextOnOverlayClick: true,
  },
  {
    highlightTargetId: 'my-employees-tour-highlight-dialog',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step10',
    },
    shape: 'rectangle',
    ignoreHighlightClick: true,
  },
  {
    highlightTargetId: 'my-employees-tour-highlight-dialog',
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step10',
    },
    shape: 'rectangle',
    border: 0.1,
    ignoreHighlightClick: true,
  },
  {
    highlightTargetId: 'back-to-dashboard-button', // 12
    nextOnOverlayClick: true,
    description: {
      text: 'guidedTour.tours.guided-tour-oa-admin-area.section3.description.step12',
    },
    border: 10,
  },
];

export const Step8DialogConfig: HighlightDialogConfig = {
  position: {
    position: 'absolute',
    vertical: {
      from: 'top',
      amount: '144px',
    },
    horizontal: {
      from: 'left',
      amount: '95px',
    },
  },
  viewSize: {
    width: '607px',
    height: '139px',
  },
};

export const Step10DialogConfig: HighlightDialogConfig = {
  position: {
    position: 'absolute',
    vertical: {
      from: 'top',
      amount: '160px',
    },
    horizontal: {
      from: 'right',
      amount: '76px',
    },
  },
  viewSize: {
    width: '607px',
    height: '260px',
  },
};

export const Step11DialogConfig: HighlightDialogConfig = {
  position: {
    position: 'absolute',
    vertical: {
      from: 'top',
      amount: 'calc((100vh - 630px) / 2.5)',
    },
    horizontal: {
      from: 'right',
      amount: '76px',
    },
  },
  viewSize: {
    width: '607px',
    height: '429px',
  },
};

export const stepDialogConfigMap = new Map([
  [8, Step8DialogConfig],
  [10, Step10DialogConfig],
  [11, Step11DialogConfig],
]);
